import { mediaMaxWidth } from 'app/lib/utils';
import { Flex, styled, css } from '@goodrx/matisse';

export const HeadingWrapper = styled(Flex)`
  flex-direction: column;
  justify-content: space-between;

  img {
    max-width: 120px;
    margin-bottom: 16px;

    ${mediaMaxWidth({
      sm: css`
        max-width: 99px;
        margin-bottom: 0;
      `,
    })};
  }

  ${mediaMaxWidth({
    sm: css`
      flex-direction: row-reverse;
      > div {
        max-width: 65%;
      }
    `,
  })};

  p {
    font-weight: 500;
  }
`;
